export default __webpack_public_path__ + "static/media/filter.bd2677f2.svg";